<template>
  <div class="order">
    <div class="" v-loading="loading">
      <div class="s_wrapper">
        <el-input class="s_input" v-model="userCode" placeholder="请输入用户编号" suffix-icon="el-icon-search"
          @change="onSearch" clearable>
        </el-input>
        <el-input class="s_input" v-model="orderNum" placeholder="请输入订单编号" suffix-icon="el-icon-search"
          @change="onSearch" clearable>
        </el-input>
        <el-input class="s_input" v-model="refundCode" placeholder="请输入售后单号" suffix-icon="el-icon-search"
          @change="onSearch" clearable>
        </el-input>
        <el-select class="s_input" v-model="status" placeholder="请输入售后状态" clearable @change="onSearch">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <!-- <el-date-picker v-model="formInline.time" @change="gettime" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期"
          style="border-radius: 10px;  margin-left: 20px; border: 1px solid #ccc" value-format="yyyy-MM-dd">
        </el-date-picker> -->
      </div>
      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="userCode" label="用户编号"></el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="orderNum" label="订单编号"></el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="refundCode" label="售后单号"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="refundAmount" label="退款金额(元)"></el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="orderTime" label="下单时间"></el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="createdTime" label="申请时间"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="status" label="售后状态">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == -1">已撤销</span> -->
              <span v-if="scope.row.status == 0">处理中</span>
              <span v-if="scope.row.status == 1">已退款</span>
              <span v-if="scope.row.status == 2">拒绝退款</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="150" header-align="center" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" v-if="scope.row.status == 0" size="small"
                @click="handleReview(scope.row)">售后处理</el-button>
              <el-button type="primary" size="small" plain @click="handleCommand(scope.row)">售后详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalCount">
    </el-pagination>
    <!-- 售后处理 -->
    <el-dialog title="售后处理" :visible.sync="dialogVisible" width="30%" @close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
        <el-row style="margin-bottom: 18px;">
          <el-col>
            <el-form-item label="处理结果：" prop="auditStatus">
              <el-radio-group v-model="ruleForm.auditStatus" @change="changeReset">
                <el-radio label="1">同意申请</el-radio>
                <el-radio label="2">拒绝申请</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="ruleForm.auditStatus == 2">
          <el-col>
            <el-form-item label="不通过原因：" prop="refuseMsg">
              <el-input resize="none" type="textarea" v-model="ruleForm.refuseMsg"
                :autosize="{ minRows: 8, maxRows: 10 }"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      refundCode: "",//售后编号
      orderNum: "",//订单编号
      userCode: "",//用户编号
      status: "",//订单状态
      tableData: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalCount: 0, // 总记录数（需要从后端获取）
      startTime: '',//开始时间
      endTime: '',//结束时间
      formInline: {
        time: []
      },//日期区间,
      statusOptions: [
        { value: "0", label: "处理中" },
        { value: "1", label: "已退款" },
        { value: "2", label: "拒绝退款" },
      ],
      // 审核信息
      ruleForm: {
        auditStatus: '',
        refuseMsg: '',
      },
      rules: {
        auditStatus: [
          { required: true, message: '请选择审核结果', trigger: 'blur' }
        ],
        refuseMsg: [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' }
        ],
      },
    }
  },
  created() {
    this.getRequestList()
  },
  methods: {
    getRequestList() {
      this.loading = true
      this.$axios
        .get(this.$api.studyTourOrderRefundList, {
          params: {
            status: this.status || null, // 订单状态：0处理中 ；1已退款；2拒绝退款
            refundCode: this.refundCode || null,
            orderNum: this.orderNum || null,
            userCode: this.userCode || null,
            // startTime: this.startTime || null,//开始时间
            // endTime: this.endTime || null,//结束时间
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 时间区间搜索
    gettime() {
      this.startTime = this.formInline.time ? this.formInline.time[0] || "" : "";
      this.endTime = this.formInline.time ? this.formInline.time[1] || "" : "";
      this.getRequestList()
    },
    // 点击查看
    handleCommand(row) {
      this.$router.push({ name: 'afterSalesOrderDet', query: { id: row.id, } })
    },
    // 点击售后处理
    handleReview(row) {
      this.dialogVisible = true
      this.$set(this.ruleForm, 'id', row.id)

    },
    // 切换配送方式的校验并清空数据
    changeReset() {
      this.$refs.ruleForm.clearValidate();//移除校验结果
      this.$set(this.ruleForm, 'refuseMsg', '')
    },
    // 重置
    resetForm() {
      this.ruleForm = {}
      this.$refs.ruleForm.resetFields();
    },
    // 售后确认
    handleSubmitForm() {
      const { auditStatus, id, refuseMsg } = this.ruleForm
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$axios.post(this.$api.studyTourOrderRefundAudit,
            { auditStatus, id, refuseMsg }
          ).then((res) => {
            const { code } = res
            if (code == 100) {
              this.$message({ message: '恭喜你，处理成功!', type: 'success' });
              this.dialogVisible = false
              this.onSearch()
            }
          }).catch((err) => {
            console.log(err);
            this.$message.error(err.desc)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },

    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getRequestList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getRequestList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getRequestList()
    },
  },
}
</script>

<style scoped lang="scss">
.order {
  .disabled_user_account {
    width: 255px;
    color: #c0c4cc;
    padding: 0 15px;
    border-radius: 10px;
    background-color: #f5f7fa;
    box-sizing: border-box;
    cursor: not-allowed;
  }
}
</style>
